// extracted by mini-css-extract-plugin
export default {"wrapper":"RgjPKwhwje","input":"xEh4s3skXb"};